import { z } from 'zod';

import { VISIBILITY_SCOPE } from '../constants';

import { CONTACT_CHANNELS } from './constants';

/**
 * Zod schema for the PUT data_exchange/contact_attempt request payload.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Exchange/operation/add_contact_attempts_data_exchange_contact_attempt_put
 */
export const zodUpsertContactAttemptPayloadSchema = z.object({
  channel: z.enum(CONTACT_CHANNELS),
  dataExchangeId: z.uuid(),
  id: z.uuid().nullable(),
  notes: z.string().trim().min(1),
  timestamp: z.iso.datetime({ offset: true }),
  visibilityScope: z.enum(VISIBILITY_SCOPE).default('company_account'),
});
